import { isError } from 'app/utils/errors';

// Type guard function to narrow the type
function isValidBlockData<B extends keyof BlockDataMap>(
  data: BlockDataWithErrorMap,
  block: B
): data is BlockDataMap {
  return data[block] !== null && !isError(data[block]);
}

export { isValidBlockData };
